import { render, staticRenderFns } from "./SPIFValuationMultiples.vue?vue&type=template&id=0d0d2c70"
import script from "./SPIFValuationMultiples.vue?vue&type=script&lang=js"
export * from "./SPIFValuationMultiples.vue?vue&type=script&lang=js"
import style0 from "./SPIFValuationMultiples.vue?vue&type=style&index=0&id=0d0d2c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports